import script from "./MaterialTypes.vue?vue&type=script&lang=ts&setup=true"
export * from "./MaterialTypes.vue?vue&type=script&lang=ts&setup=true"

import "./MaterialTypes.vue?vue&type=style&index=0&id=92d00ed2&scoped=true&lang=less"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92d00ed2"]])

export default __exports__